import { forwardRef } from 'react'

import { BankCardId, CardIssuer, CardSystem } from 'app/dataTypes/acquiring/recurrent/cards'

import { CardTemplate } from './CardTemplate'

type Props = {
  id: BankCardId
  groupName: string
  label: string
  lastFourDigits?: string
  system: CardSystem
  issuer: CardIssuer
  checked?: boolean
  onTrashButtonClick?: (id: BankCardId) => Promise<boolean>
  onChangeValue?: (id: BankCardId) => void
}

export const CardBank = forwardRef<HTMLInputElement, Props>(
  (
    {
      id,
      groupName,
      label,
      lastFourDigits,
      system,
      issuer,
      checked,
      onTrashButtonClick,
      onChangeValue,
    },
    ref,
  ) => {
    return (
      <CardTemplate
        id={id}
        ref={ref}
        groupName={groupName}
        label={label}
        lastFourDigits={lastFourDigits}
        system={system}
        issuer={issuer}
        checked={checked}
        onTrashButtonClick={onTrashButtonClick}
        onChangeValue={onChangeValue}
      >
        {''}
      </CardTemplate>
    )
  },
)
